
import { Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import RadioButtonGroup from "@/components/common/RadioButtonGroup.vue";
import radioOptions from "@/data/filters/radioOptions";
import { cloneDeep, isEqual } from "lodash-es";

import LIST_DIRECTORY from "@/apollo/directory/ListDirectory.gql";
import GET_ALL_SKILLS from "@/apollo/skills/SearchAllSkills.gql";
import GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL from "@/apollo/profile/profileDetails/management/GetProfileDetailByManagementAll.gql";

import DirectoryMixins from "@/mixins/directory/DirectoryMixins";

import LocationCollectionFilters from "@/components/companyContractors/LocationCollectionFiltersNewV2.vue";
import DefaultContentLayoutTalentMapping from "@/components/scaffold/DefaultContentLayoutTalentMapping.vue";
import CardPagination from "@/components/card/CardPagination.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import InvitationSideBar from "@/components/companyContractors/invitationsidebar.vue";

import ActionPanel from "@/components/common/ActionsPanel.vue";

import {
  getFiltersDataFromQuery,
  joinQueryValues,
} from "@/helpers/router/prepareFiltersQuery";
import {
  getPaginationDataFromQuery,
  getPaginationQuery,
} from "@/helpers/router/preparePaginationQuery";

import paginationConfig from "@/data/paginationConfig";
import locationCollectionFiltersTemplate from "@/data/filtersTemplates/locationCollectionFiltersTemplate";

import {
  Company,
  Contractor,
  User,
  Contractor_Bool_Exp,
  User_Profile_Bool_Exp,
} from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import Roles from "@/entities/Roles";
import PaginationConfig from "@/entities/PaginationConfig";
import LocationCollectionFiltersQuery from "@/entities/filters/LocationCollectionFiltersQuery";
import { getEmptyFiltersResultMessage } from "@/helpers/lists/emptyListMessages";
import ElementsSizeProvider from "@/components/uiSize/ElementsSizeProvider.vue";
import CardsContainer from "@/components/card/CardsContainer.vue";
import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageContractors.vue";
import getStateQueryConditions from "@/helpers/locations/stateQueryConditions";
import * as VueGoogleMaps from "vue2-google-maps";
import ContractorLocationCardToLoop from "@/components/companyContractors/ContractorLocationCardToLoopV2.vue";
import axios from "axios";
import ScrollableContainer from "@/components/common/ScrollableContainerV2.vue";
import RouteParams from "@/entities/RouteParams";
import FormGroup from "@/components/form/FormGroup.vue";
import UserAvailable from "@/entities/filters/UserAvailable";
import RadioOption from "@/entities/RadioOption";
import { GEO_COORDS_API, GEO_COORDS_API_KEY, VUE_GOOGLEMAP_API_KEY } from "@/data/constants";
import Spinner from "@/components/common/Spinner.vue";
import { makeNameQuery, makeNameQuery1 } from "@/helpers/queryHelperFunctions";

Vue.use(VueGoogleMaps, {
  load: {
    key: VUE_GOOGLEMAP_API_KEY,
    v: "3",
    libraries: "places",
  },
});
// const DEFAULT_CENTER = { lat: 40.7128, lng: -100.0059 };
const DEFAULT_CENTER = { lat: 40.7128, lng: -100.1667 };
const DEFAULT_ZOOM = 4;
@Component({
  components: {
    EmptyListImageContractors,
    FormGroup,
    CardsContainer,
    ElementsSizeProvider,
    LocationCollectionFilters,
    DefaultContentLayoutTalentMapping,
    CardPagination,
    EmptyListPlaceholder,
    LoadingOverlay,
    InvitationSideBar,
    ActionPanel,
    ContractorLocationCardToLoop,
    ScrollableContainer,
    RadioButtonGroup,
    Spinner
  },

  apollo: {
    contractors: {
      query: LIST_DIRECTORY,
      variables() {
        return this.directoryFilter;
      },
      skip() {
        return this.skipQuery;
      },
      update(data) {
        this.paginationConfig.total = data.total?.aggregate?.count;
        this.paginationConfig.loadedCount = data.contractor?.length;
        this.totalElements = data.contractor?.length;
        this.$emit("contractorsTotalChanged", this.paginationConfig.total);
        return data.contractor;
      },
      error() {
        this.isLoading = false
      }
    },
  },
})
export default class TalentMapping extends mixins(DirectoryMixins) {
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, default: false })
  readonly favoriteContractors!: boolean;
  @Prop({ type: Boolean, default: false }) readonly canAddProject!: boolean;
  @Prop({ type: Boolean, default: false }) readonly managerDatabase!: boolean;
  available: UserAvailable = this.$route.query?.available as UserAvailable || locationCollectionFiltersTemplate.available;
  radioOptions: RadioOption[] = radioOptions;
  isLoading: boolean = false;
  contractorLocationCardModal: boolean = false;

  contractors: Contractor[] | undefined = [];
  paginatedContructors: Contractor[] | undefined = [];

  paginationConfig: PaginationConfig = { ...paginationConfig };

  directoryFilters: LocationCollectionFiltersQuery = cloneDeep(
    locationCollectionFiltersTemplate
  );
  markerFilteredContractors = [];


  showContractors: boolean = false;
  showContractorFilters: boolean = true;
  contractorsAndPositions = [];
  test = [];
  user: {};
  locationMarker: {};
  rating: {};
  isContractorAvailble: boolean = false;
  isFiltersAvailble: boolean = true;
  latitudeValue: number = 0;
  longitudeValue: number = 0;
  countryName = "";
  isHovered = false;
  totalElements = 0;
  isZoomed = true;
  selectedCountry: string = "";
  numberOfContractors = 0;
  hoverTimeout = null;
  heading = "Contractors";
  countryAndCity = "";
  scale = 0.18;
  // scale = 1;
  center = DEFAULT_CENTER// North America center;
  mapHeight = "100vh";
  mapStyles = []; // Add your custom map styles here
  zoom = DEFAULT_ZOOM; // Zoom level of the map
  //   blackMarkerIcon = {
  //   path: 'M60.9 98.7 c-7.7 -8.8 -17.4 -22.5 -20.3 -28.7 -5.5 -11.6 -3.2 -23.9 6 -32 7.9 -6.8 18.5 -8.9 28.6 -5.4 10.3 3.5 18.2 14.5 18.1 25.3 -0.1 6.5 -1.8 10.9 -8 20.6 -6.4 9.8 -18.7 24.7 -20.3 24.4 -0.3 0 -2.1 -2 -4.1 -4.2z m10.6 -28.1 c5.1 -2.2 7.7 -6.9 7.2 -13.4 -0.3 -4.1 -1 -5.9 -3.2 -8.2 -5.9 -6.1 -14.8 -5.9 -20.4 0.5 -2.5 2.9 -3.1 4.4 -3.1 8.3 0 10.8 9.4 17 19.5 12.8z',
  //   fillColor: 'black',
  //   fillOpacity: 1,
  //   scale: this.scale,
  //   strokeWeight: 0,
  // };
  allSkills = [];
  maxmin = { min: 0, max: 0 };
  selectedMarker = null;
  isPopupOpen = false;
  numberOfContractorsWithOutLocation = 0;

  totalCount: number = 0;





  handleMarkerMouseOver(e) {
    this.filterContractorByCountry(e, DEFAULT_ZOOM)
  }
  updateFavorite(cont1, favId) {
    const cont = { ...cont1 }
    if (favId) {
      cont.contractors.user = { ...cont.contractors.user, favorited_by_users: [...(cont.contractors.user?.favorited_by_users || []), { id: favId }] }
    }
    else {
      cont.contractors.user = { ...cont.contractors.user, favorited_by_users: [] }

    }
    return cont
  }
  onUpdateCard(favId, con, index) {
    const filtermarkers = [...this.markerFilteredContractors]
    const cont = filtermarkers[index];
    if (con.contractors.id === cont.contractors.id) {

      filtermarkers[index] = this.updateFavorite(cont, favId);
      this.markerFilteredContractors = filtermarkers

      const index1 = this.contractorsAndPositions.findIndex(a => a.contractors.id === con.contractors.id)
      if (index1 !== -1) {

        const cont1 = this.contractorsAndPositions[index1];
        const newmaps = [...this.contractorsAndPositions]
        newmaps[index1] = this.updateFavorite(cont1, favId);
        this.contractorsAndPositions = newmaps

      }
    }
  }
  onUpdateCardList(favId, con, index) {

    const cont = this.contractorsAndPositions[index];
    if (con.contractors.id === cont.contractors.id) {
      const newmaps = [...this.contractorsAndPositions]
      newmaps[index] = this.updateFavorite(cont, favId);
      this.contractorsAndPositions = newmaps


      const index1 = this.markerFilteredContractors.findIndex(a => a.contractors?.id === con.contractors.id)
      if (index1 !== -1) {

        const cont1 = this.markerFilteredContractors[index1];
        const markers = [...this.markerFilteredContractors]
        markers[index1] = this.updateFavorite(cont1, favId);
        this.markerFilteredContractors = markers

      }
    }
  }
  @Watch('available')
  availableFilter() {
    this.isLoading = true;
    this.contractors = [];
    this.markerFilteredContractors = []
    this.contractorsAndPositions = []
    this.directoryFilters.available = this.available

  }

  @Watch('contractors', { deep: false })
  contractorsDate() {
    this.isLoading = true;
    this.showContractorData();
  }
  get isManagerDatabase(): boolean {
    return this.$route.name === RouteNames.MANAGER_CONTRACTOR_DATABASE;
  }

  calculatecenter() {
    if (this.contractorsAndPositions.length === 0) {
      // Default center if no markers present
      return { lat: 20, lng: 0 };
    } else {
      const totalMarkers = this.contractorsAndPositions.length;
      const sumLat = this.contractorsAndPositions.reduce(
        (sum, pos) => sum + pos.position.lat,
        0
      );
      const sumLng = this.contractorsAndPositions.reduce(
        (sum, jsonObj) => sum + jsonObj.position.lng,
        0
      );
      const avgLat = sumLat / totalMarkers;
      const avgLng = sumLng / totalMarkers;
      return { lat: avgLat, lng: avgLng };
    }
  }


  openPopup(marker) {
    this.selectedMarker = marker;
    this.isPopupOpen = true;
  }
  closePopup() {
    this.isPopupOpen = false;
    this.isZoomed = true;
    // this.contractorsAndPositions = [];
    this.markerFilteredContractors = []
    this.zoom = DEFAULT_ZOOM;
    // this.showContractorData();
  }

  async getProfilesByManagement(contractorUserId) {
    return this.$apollo
      .query({
        query: GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL,
        variables: {
          userId: contractorUserId,
        },
      })
      .then((response) => {
        // Handle the response data here if needed
        return response.data; // Return the response
      })
      .catch((error) => {
        // Handle the error here if needed
        throw error; // Throw the error
      });
  }

  updateMapHeight() {
    const windowHeight = window.innerHeight;
    const doc = document.querySelector('.b-talentMapping_container') as HTMLDivElement
    if (doc) {
      this.mapHeight = `${doc.getBoundingClientRect().height - 16}px`
    } else {

      this.mapHeight = `${windowHeight * 0.88}px`; // Set the map height to 50% of the viewport height
    }
  }

  async getSkills() {
    try {
      const response = await this.$apollo.query({
        query: GET_ALL_SKILLS,
      });
      // Handle the response data here if needed

      return response.data.skill; // Return the response
    } catch (error) {
      // Handle the error here if needed
      throw error; // Throw the error
    }
  }

  // async getSkills (skillName){
  //     return this.$apollo.query({
  //       query: GET_ALL_SKILLS,
  //       variables: {
  //         search: 4939
  //       },
  //     }).then(response => {
  //       // Handle the response data here if needed
  //       return response.data; // Return the response
  //     }).catch(error => {
  //       // Handle the error here if needed
  //       throw error; // Throw the error
  //     });

  // }

  // get filteredContractorData() {
  //   if (this.selectedCountry === "") {
  //     return this.contractorsAndPositions;
  //   } else {
  //     return this.contractorsAndPositions.filter(
  //       (contractor) => contractor.country === this.selectedCountry
  //     );
  //   }
  // }

  async countOfContractorsWithOutLocation() {
    //this.numberOfContractorsWithOutLocation = await this.contractors.filter(contractor => !contractor.user.profile.country || contractor.user.profile.country.trim() === "").length;
    let count = 0;

    this.contractorsAndPositions.forEach((item) => {
      if (
        item.locationProfile?.country ||
        item.contractors.user.profile?.country
      ) {
        count++;
      }
    });

    this.numberOfContractorsWithOutLocation = count;
  }

  @Watch("selectedCountry")
  onSelectedCountryChanged(newCountry: string, oldCountry: string) {
    // Perform any necessary actions when selectedCountry changes
  }

  get managerHasAccess(): boolean {
    return this.isManagerDatabase || this.favoriteContractors;
  }

  contractorPageRoute(employeeUserId: string): RouteParams<{ id: string }> {
    // if (this.contractorDetailsPageRoute) {
    //   return this.contractorDetailsPageRoute;
    // }

    return {
      name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
      params: {
        id: employeeUserId,
      },
    };
  }

  async handleMarkerClick(marker, position) {
    this.isZoomed = false;
    let isFirst = true;
    let location = "";
    let filteredContractors = [];
    if (
      marker &&
      marker?.contractors?.user &&
      marker?.contractors?.user?.profile &&
      marker?.contractors?.user?.profile?.city &&
      marker?.contractors?.user?.profile?.country
    ) {
      location =
        marker.contractors.user.profile.country +
        " , " +
        marker.contractors.user.profile.city;
    } else {
      location =
        marker?.locationProfile?.country +
        " , " +
        marker?.locationProfile?.city;
      isFirst = false;
    }
    if (isFirst) {
      filteredContractors = this.contractorsAndPositions.filter((item) => {
        const country =
          item.contractors.user.profile?.country || item.locationProfile?.country;
        return (
          country !== null &&
          country !== undefined &&
          country.toLowerCase() ===
          marker.contractors.user.profile?.country?.toLowerCase()
        );
      });
    } else {
      filteredContractors = this.contractorsAndPositions.filter(
        (obj) =>
          obj.locationProfile?.country?.toLowerCase() ===
          marker.locationProfile?.country?.toLowerCase()
      );
    }
    const coordinates = await this.fetchCoordinates(location);
    // this.contractorsAndPositions = [];
    this.center = coordinates; //position ;
    this.zoom = 6;
    this.selectedMarker = marker;
    // this.contractorsAndPositions = filteredContractors;
    this.markerFilteredContractors = filteredContractors

  }

  filterConractorByCountryName(data, countryName: string): [] {
    return data.filter((item) => {
      return (
        item.contractors?.user?.profile?.country?.toLowerCase() ===
        countryName?.toLowerCase()
      );
    });
  }

  filterUniqueContractors(filteredArray) {
    return filteredArray.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          (obj) =>
            obj.contractors.id.toLowerCase() ===
            item.contractors.id.toLowerCase()
        )
    );
  }

  async filterContractorByCountry(marker, zoom = 14) {
    this.selectedMarker = marker;
    this.isPopupOpen = true;
    this.zoom = zoom;
    this.countryName = "";
    this.countryAndCity = "";
    if (marker?.contractors?.user?.profile?.country !== null) {
      this.countryName = marker.contractors.user.profile.country;
      this.countryAndCity =
        marker.contractors.user.profile.country +
        " " +
        marker.contractors.user.profile.city;
    } else {
      this.countryName = "";
      this.countryName = marker.locationProfile.country;
      this.countryAndCity =
        marker.locationProfile.country + " " + marker.locationProfile.city;
    }

    const filteredContractors = this.contractorsAndPositions.filter((item) => {
      const country =
        item.contractors.user.profile.country || item.locationProfile.country;
      return (
        country !== null &&
        country !== undefined &&
        country.toLowerCase() === this.countryName.toLowerCase()
      );
    });
    this.numberOfContractors = filteredContractors.length;
    // this.contractorsAndPositions = filteredContractors;
    this.markerFilteredContractors = filteredContractors
    const coordinates = await this.fetchCoordinates(this.countryAndCity);
    this.center = coordinates;
  }
  resetAllFilters() {
    this.showContractorData();
    this.isContractorAvailble = false;
    this.isFiltersAvailble = true;
    // this.center = this.calculatecenter();
    this.center = DEFAULT_CENTER;
    this.zoom = DEFAULT_ZOOM;

  }

  async extractCityAndCountry(userProfilesData): Promise<{} | null> {
    let latestProfile = null;

    for (const profile of userProfilesData.user_profile_by_managements) {
      if (!latestProfile || profile.updated_at > latestProfile.updated_at) {
        latestProfile = profile;
      }
    }

    if (latestProfile && latestProfile.city && latestProfile.country) {
      return {
        city: latestProfile.city,
        country: latestProfile.country,
        company_name: latestProfile.company_name,
        job_title: latestProfile.job_title,
        max_rate: latestProfile?.max_rate,
        min_rate: latestProfile?.min_rate,
      };
    }

    return null;
  }
  async checkMaxMin(contractor, locationProfile) {
    this.maxmin = { min: 0, max: 0 };
    if (
      contractor &&
      contractor?.user &&
      contractor?.user?.profile &&
      contractor?.user?.profile?.max_rate &&
      contractor?.user?.profile?.min_rate
    ) {
      this.maxmin = { min: contractor.user.profile.min_rate ? contractor.user.profile.min_rate : contractor.user.user_profile_by_managements.min_rate, max: contractor.user.profile.max_rate ? contractor.user.profile.max_rate : contractor.user.user_profile_by_managements.max_rate };
    } else {
      this.maxmin = { min: locationProfile?.min_rate, max: locationProfile?.max_rate };
    }
  }
  async showContractorData() {
    let locationProfile = null;
    let location = "";
    let count = 0;
    const mapAndPositions = []
    const citiesObj = {}

    for (const contractor of this.contractors) {
      // let userProfilesData = await this.getProfilesByManagement(
      //   contractor.user.id
      // );
      locationProfile = await this.extractCityAndCountry(contractor.user);
      if (
        contractor &&
        contractor.user &&
        contractor.user.profile &&
        contractor.user.profile.city &&
        contractor.user.profile.country
      ) {
        location =
          contractor.user.profile.country + " " + contractor.user.profile.city;
      } else {
        if (locationProfile === null) {
          count++;
          continue; // Skip the record if location is empty or null
        }
        location = locationProfile.country + " " + locationProfile.city;
      }

      if (!location.trim()) {
        count++;
        continue;
      }
      this.checkMaxMin(contractor, locationProfile);
      const locInfo = citiesObj[location]
      let coordinates = locInfo?.coordinates || null;
      if (!locInfo?.location) {
        coordinates = await this.fetchCoordinates(location);
        citiesObj[location] = { location, coordinates }
        }
      if (coordinates !== null) {
        const markers = {
          maxmin: this.maxmin,
          rate_unit: contractor?.user.profile.rate_unit || null,
          locationProfile: locationProfile,
          contractors: contractor,
          position: {
            lat: parseFloat(coordinates.lat),
            lng: parseFloat(coordinates.lng),
          },
        };

        mapAndPositions.push(markers);
      }
      this.numberOfContractorsWithOutLocation = count;
    }
    this.contractorsAndPositions = mapAndPositions;
        if (isEqual(this.directoryFilters, locationCollectionFiltersTemplate)) {
      this.center = DEFAULT_CENTER
    }else {
      this.center = this.calculatecenter();

    }
    this.isLoading = false;

  }

  async fetchCoordinates(address: string) {
    const params = {
      q: address,
      apiKey: GEO_COORDS_API_KEY,
    };

    try {
      const response = await axios.get(
        GEO_COORDS_API,
        {
          params: params,
        }
      );

      if (
        response.data.items[0]?.position?.lat !== null &&
        response.data.items[0]?.position?.lng !== null
      ) {
        return response.data.items[0]?.position;
      } else {
        return null;
        // throw new Error("Latitude or longitude value is null");
      }
    } catch (error) {
      // Handle the error
      throw error;
    }
  }

  getProfile(con) {
    if (
      con &&
      con.contractors &&
      con.contractors.user &&
      con.contractors.user.profile
    ) {
      const profile = con.contractors.user.profile;
      return profile || ""; // Set empty string if skill is null
    }
    return ""; // Handle the case where the object or its properties are undefined
  }

  getFirstSkill(con) {
    if (
      con &&
      con.contractors &&
      con.contractors.user &&
      con.contractors.user.profile
    ) {
      const skill = con.contractors.user.profile.skills[0]?.skill?.name;
      return skill || ""; // Set empty string if skill is null
    }
    return ""; // Handle the case where the object or its properties are undefined
  }

  getSecondSkill(con) {
    if (
      con &&
      con.contractors &&
      con.contractors.user &&
      con.contractors.user.profile
    ) {
      const skill = con.contractors.user.profile.skills[1]?.skill?.name;
      return skill || ""; // Set empty string if skill is null
    }
    return ""; // Handle the case where the object or its properties are undefined
  }

  get empty(): boolean {
    if (!this.contractors) {
      return false;
    }
    return this.contractors.length === 0;
  }

  get hasData(): boolean {
    return Boolean(this.contractors);
  }

  get invitationButtonShown(): boolean {
    return !this.favoriteContractors && this.filtersEmpty;
  }

  get filtersEmpty(): boolean {
    return isEqual(this.directoryFilters, locationCollectionFiltersTemplate);
  }

  get emptyListPlaceholder(): string {
    if (this.favoriteContractors) {
      if (this.filtersEmpty) {
        return "You have no favorite contractors at the moment, but you might like someone in the Talent Directory";
      }

      return getEmptyFiltersResultMessage("favorite contractors");
    }

    if (this.filtersEmpty) {
      return "Talent Mapping";
    }

    return getEmptyFiltersResultMessage("contractors");
  }

  // get emptyListSubtitle(): string{
  //   return "Start adding contractors to your Talent Directory";
  // }

  get loading(): boolean {
    return this.$apollo.queries.contractors.loading || this.isLoading;
  }

  get isManager(): boolean {
    return this.currentUser.role === Roles.MANAGER;
  }

  get currentUserManagerId(): string | undefined {
    return this.currentUser?.role === Roles.MANAGER
      ? this.currentUser.manager?.id
      : undefined;
  }

  get directoryFilter(): any {
    const { page, limit } = this.paginationConfig;

    const {
      countries,
      states,
      cities,
      titles,
      skills,
      managers,
      projects,
      name,
      available,
      minRate,
      maxRate,
    } = this.directoryFilters;

    const nextOffset = page * limit - limit;
    const filterConditions: Contractor_Bool_Exp[] = [
      {
        approved: { _eq: true },
        deleted: { _eq: false },

      },
      {user: {
        user_profile_by_managements: {}
      }}
    ];

    if (this.favoriteContractors) {
      const managerConditions = !this.currentUserManagerId
        ? {}
        : {
          managers: {
            _and: [
              {
                manager: {
                  id: {
                    _eq: this.currentUserManagerId,
                  },
                },
              },
              {
                approved: {
                  _eq: true,
                },
              },
            ],
          },
        };

      filterConditions.push({
        _and: [
          {
            user: {
              favorited_by_users: {
                favorited_by_id: {
                  _eq: this.currentUser.id,
                },
              },
            },
          },
          managerConditions,
        ],
      });
    }

    if (this.isManager && this.isManagerDatabase) {
      const managerId = this.currentUser.manager!.id;

      filterConditions.push({
        managers: {
          _and: [
            { manager_id: { _eq: managerId } },
            { approved: { _eq: true } },
          ],
        },
      });
    }

    if (name) {
      const nameConds = [
        ...makeNameQuery1(name, ['']),
         { profile: { skills: { skill: { name: { _ilike: `%${name}%` } } } } } ];
      if (!titles.length) {
        nameConds.push({
            profile: {
              job_title: { _ilike: `%${name}%` }
            }
        });
        nameConds.push({
            experiences: {
              job_title: { _ilike: `%${name}%` }
            }

        });
      }

      filterConditions.push({
        user: {

        _or: nameConds
        }
      });
    }

    if (countries.length) {
      filterConditions.push({
        user: {
          _and: [
            {
              user_profile_by_managements: {
                added_by_id: {
                  _eq: this.currentUser.id,
                }
              }
            },
          ],
          _or: [
            { profile: { country: { _in: countries } } },

            { user_profile_by_managements: { country: { _in: countries } } },
          ],
        },
      });
    }
    if (states.length) {
      filterConditions.push({
        user: {
          profile: {
            state: getStateQueryConditions({ countries, states }),
          },
        },
      });
    }

    if (cities.length) {
      filterConditions.push({
        user: {
          profile: {
            city: { _in: cities },
          },
        },
      });
    }

    if (available !== "all") {
      filterConditions.push({
        user: {
          available: { _eq: available === "yes" },
        },
      });
    }

    if (titles.length) {

      filterConditions.push({
        user: {
          _and: [
            {
              user_profile_by_managements: {
                added_by_id: {
                  _eq: this.currentUser.id,
                }
              }
            },
          ],
          _or: [
            {
              profile: {
                job_title: { _in: titles },
              },
            },
            {
              experiences: {
                job_title: { _in: titles }
              }
            },
          ],
        },
      });
    }

    if (skills.length) {
      filterConditions.push({
        user: {
          profile: {
            skills: {
              skill_id: { _in: skills },
            },
          },
        },
      });
    }

    if (managers.length) {
      filterConditions.push({
        managers: {
          _and: [
            { manager_id: { _in: managers } },
            { approved: { _eq: true } },
          ],
        },
      });
    }

    if (projects.length) {
      filterConditions.push({
        project_activities: {
          project: {
            id: { _in: projects },
          },
        },
      });
    }

    if (minRate || maxRate) {
      const minConditions: User_Profile_Bool_Exp[] = [];
      const maxConditions: User_Profile_Bool_Exp[] = [];

      if (minRate) {
        minConditions.push({ min_rate: { _gte: minRate } });
        maxConditions.push({ max_rate: { _gte: minRate } });
      }
      if (maxRate) {
        minConditions.push({ min_rate: { _lte: maxRate } });
        maxConditions.push({ max_rate: { _lte: maxRate } });
      }

      if (minConditions.length && maxConditions.length) {
        filterConditions.push({
          user: {
            profile: {
              _or: [{ _and: minConditions }, { _and: maxConditions }],
            },
          },
        });
      }
    }

    return {
      offset: nextOffset,
      limit: 500,
      where: {
        _and: filterConditions,
      },
      id: this.currentUser.id,
      managerUserId: this.currentUser.id,
      companyId: this.company.id,
    };
  }

  get queryPropsToWatch(): string {
    return JSON.stringify([this.directoryFilters, this.paginationConfig]);
  }

  get queryParams(): {
    filters: LocationCollectionFiltersQuery;
    pagination: PaginationConfig;
  } {
    const query = this.$route.query;
    const { min_rate: minRate, max_rate: maxRate, ...queryParams } = query;

    const queryData = {
      minRate,
      maxRate,
      ...queryParams,
    };

    return {
      filters: getFiltersDataFromQuery<LocationCollectionFiltersQuery>(
        locationCollectionFiltersTemplate,
        queryData
      ),
      pagination: {
        ...this.paginationConfig,
        ...getPaginationDataFromQuery(query),
      },
    };
  }

  get isChosenPageEmpty(): boolean {
    const collectionEmpty = this.contractors?.length === 0;
    const notFirstPage = this.paginationConfig.page !== 1;

    return !this.loading && collectionEmpty && notFirstPage;
  }

  @Watch("queryPropsToWatch")
  updateQuery(): void {
    if (this.isChosenPageEmpty) {
      return this.showFirstPage();
    }

    const paginationQuery = getPaginationQuery(this.paginationConfig);

    const { minRate, maxRate, ...filtersData } = this.directoryFilters;

    const query = joinQueryValues({
      ...paginationQuery,
      ...filtersData,
      min_rate: minRate,
      max_rate: maxRate,
    });

    if (isEqual(query, this.$route.query)) {
      return;
    }

    this.$router.push({ query }).catch(() => { });
  }

  @Watch("$route.query", { immediate: true })
  onQueryChange(): void {
    const { filters, pagination } = this.queryParams;

    this.directoryFilters = filters;
    this.paginationConfig = pagination;
  }

  async mounted() {
    if (!!this.company) {
      this.isLoading = true;
      this.$apollo.queries.contractors.skip = false;
    }
    this.allSkills = await this.getSkills();
    setTimeout(() => {
      this.contractorsAndPositions = [];
      this.markerFilteredContractors = []
      this.showContractorData();
    }, 1500);
    this.updateMapHeight(); // Call the function to adjust the height on initial load
    window.addEventListener("resize", this.updateMapHeight); // Listen for window resize events
  }

  showFirstPage(): void {
    this.paginationConfig = {
      ...this.paginationConfig,
      page: paginationConfig.page,
    };
  }

  managerAccessApproved(contractor: Contractor): boolean {
    return Boolean(contractor?.user.contracts[0]?.managers[0]?.approved);
  }

  async filterContractorsByOptions(
    updatedFilters: LocationCollectionFiltersQuery
  ) {
    this.contractorsAndPositions = [];
    this.contractors = [];
    this.markerFilteredContractors = []

    this.showFirstPage()
    this.directoryFilters = { ...this.directoryFilters, titles: updatedFilters.titles, countries: updatedFilters.countries, skills: updatedFilters.skills, name: updatedFilters.name }
  }

  resetFilters(): void {
    if (isEqual(this.directoryFilters, locationCollectionFiltersTemplate)) {
      return;
    }
    this.available = locationCollectionFiltersTemplate.available
    this.directoryFilters = cloneDeep(locationCollectionFiltersTemplate);
    this.paginationConfig = { ...paginationConfig };
  }

  message(userId: string): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: userId,
      },
    });
  }

  async handleRefetch(): Promise<any> {
    this.isLoading = true;
    await this.$apollo.queries.contractors.refetch();
    this.showContractorData()
    this.$emit("refetchRequests");
    this.$emit("refetchRequestsContractorsNumber");
  }

  prepareFilters(filterValues: Record<string, any>): void {
    this.directoryFilters = {
      ...this.directoryFilters,
      ...filterValues,
    };
  }
}
